<template>
    <div class="inform">
      <div class="container banner">
        <img src="../../static/img/about/banner.png" style="width: 100%;margin-bottom: 60px;" alt="">
        <div class="content">
          <div class="nav-title">
            <h1 class="title-name">月子咨询</h1>
            <hr>
          </div>
          <div class="article">
            <img src="../../static/img/inform/map.png" class="map" alt="">
            <div class="connect">
              <div class="connect-cate">
                <div class="c-way">
                  <img src="../../static/img/inform/tel.png" alt="">
                  <div class="c-way-d">
                    <p class="d-title">咨询热线</p>
                    <p class="d-way">13861028998</p>
                  </div>
                </div>
                <div class="c-way">
                  <img src="../../static/img/inform/email.png" alt="">
                  <div class="c-way-d">
                    <p class="d-title">合美邮箱</p>
                    <p class="d-way">582515087@qq.com</p>
                  </div>
                </div>
                <div style="clear:both;"></div>
              </div>
              <div class="connect-cate">
                <p class="title-s">
                  关注我们
                </p>
                <div class="follow-box">
                  <img src="../../static/img/inform/ewm.png" alt="">
                  <div class="follow-tip">
                    <p class="tip-f">手机扫一扫</p>
                    <p class="tip-s">关注合美月子中心</p>
                  </div>
                </div>
              </div>
              <div class="connect-cate">
                <p class="title-s">
                  合美地址
                </p>
                <div class="address">
                  电话：13921031020<br>
                  邮箱：常州市武进武宜南路698号-15号三楼（华美达酒店旁）
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "inform"
    }
</script>

<style scoped lang="less">
.inform{
  .article{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 80px;
    .map{
      width: 589px;
      height: 467px;
    }
    .connect{
      width: 600px;
      padding-right: 20px;
      .connect-cate{
        border-bottom: 1px solid #ebebeb;
        padding: 25px 0;
        .c-way{
          float: left;
          width: 50%;
          img{
            width: 42px;
            height: 42px;
            display: inline-block;
          }
          .c-way-d{
            display: inline-block;
            .d-title{
              font-size: 18px;
              color:#666666;
            }
            .d-way{
              font-size: 22px;
            }
          }
        }
        .follow-box{
          img{
            display: inline-block;
            width: 88px;
            height: 88px;
            margin-right: 10px;
            vertical-align: middle;
          }
          .follow-tip{
            vertical-align: middle;
            display: inline-block;
            .tip-f{
              font-size: 22px;
              color:#4C204D;
            }
            .tip-s{
              font-size: 18px;
              color:#666666;
            }
          }
        }
        .address{
          font-size: 18px;
        }
      }
    }
    .title-s{
      border-left: 3px solid #f2ab43;
      padding-left: 12px;
      font-size: 24px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inform.vue